import React, { createContext, useCallback, useContext, useState } from "react";
import { useSelector } from "react-redux";

import moment from "moment";

import { isNonEmptyString, isNumber } from "@cayuse/shared-react.utils.type-checks";

import { budgetBuilderSelectors, shellSelectors, tenantSelectors } from "store/selectors";
import { toNumber } from "utils/budgetBuilder";


const TenantFormatterContext = createContext({
	currencyFormatter: (value, defaultIfEmpty = "--", overrideDisplayCents = null) => value || defaultIfEmpty,
	dateFormatter: value => value,
	dateTimeFormatter: value => value
});

export const useTenantFormatter = () => useContext(TenantFormatterContext);

export const TenantFormatterWrapper = ({ children }) => {
	const displayCents = useSelector(budgetBuilderSelectors.displayCents);
	// TODO: Implement real currency from backend
	const [ currency, setCurrency ] = useState("USD");
	const locale = useSelector(shellSelectors.locale);
	const { dateFormat, datetimeFormat } = useSelector(tenantSelectors.tenant);

	const dateFormatter = useCallback(
		date => moment(date).format(dateFormat),
		[ dateFormat ]
	);

	const dateTimeFormatter = useCallback(
		date => moment(date).format(datetimeFormat),
		[ datetimeFormat ]
	);

	const currencyFormatter = useCallback(
		(value, defaultIfEmpty = "--", overrideDisplayCents = null) => {
			let doDisplayCents = overrideDisplayCents === true || overrideDisplayCents === false
				? overrideDisplayCents
				: displayCents;
			const maximumFractionDigits = doDisplayCents ? 2 : 0;
			const formatter = new Intl.NumberFormat(
				locale,
				{ style: "currency", currency, maximumFractionDigits },
			);
			value = toNumber(value);
			const formattedCurrency = (isNumber(value) && value !== 0 && !isNaN(value))
				? formatter.format(value)
				: "";

			if (!isNonEmptyString(formattedCurrency)) {
				return isNumber(defaultIfEmpty)
					? formatter.format(defaultIfEmpty)
					: defaultIfEmpty;
			}

			return formattedCurrency;
		},
		[ currency, displayCents, locale ],
	);

	return (
		<TenantFormatterContext.Provider value={{ currencyFormatter, dateFormatter, dateTimeFormatter }}>
			{children}
		</TenantFormatterContext.Provider>
	);
};

